

















import Vue from 'vue'

import { camelizeKeys, kebabToCamelCase } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'
import { capitalize } from 'lodash'

const settings = kebabToCamelCase(require('./disclosureSexual.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
    }
  },
  props: {
    traumaType: {
      type: String,
      required: true,
    },
  },
  computed: {
    instructionsForTrauma() {
      return this.settings['instructions' + capitalize(this.traumaType)]
    },
  },
  mounted() {
    //reset the values on mount, if we have more than one trauma, it should be reset every time
    this.$set(this.value, 'item_1', null)
    this.$set(this.value, 'item_2', null)
    this.$set(this.value, 'item_3', null)
    this.$set(this.value, 'item_4', null)
    this.$set(this.value, 'item_5', null)
    this.$set(this.value, 'item_6', null)
    this.$set(this.value, 'item_7', null)
    this.$delete(this.value, 'id')
    this.$set(this.value, 'description_of_item7', null)
    this.$set(this.value, 'trauma_type', this.traumaType)
  },
})
